import React, { useRef } from 'react'
import * as XLSX from 'xlsx/xlsx.mjs';
import IconButton from './IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faSave } from '@fortawesome/free-solid-svg-icons';

function convertToArray(str) {

  return str.split('|~');
}

function formatFloatIfNeeded(inputString) {
  // Check if the string contains a decimal point
  if (`${inputString}`?.includes('.')) {
      const num = parseFloat(inputString);

      // Check if the number is a valid float and not an integer
      if (!isNaN(num) && num % 1 !== 0) {
          // Format to two decimal places and return
          return num.toFixed(2);
      }
  }
  
  // Return the raw string if no conditions are met
  return inputString;
}

export default function Table({ tableHeaders, tableBody, className, onCloseClick }) {
  const tableRef = useRef()
  let tableBodyKeys = Object.keys(tableBody).map((key) => (convertToArray(key)))
  let tableBodySectionLengths = Object.values(tableBody).map((rowSet) => (rowSet.length))

  const save = () => {
    let workbook = XLSX.utils.table_to_book(tableRef.current);

    // Process Data (add a new row)
    let ws = workbook.Sheets["Sheet1"];
    // XLSX.utils.sheet_add_aoa(ws, [["Created " + new Date().toISOString()]], { origin: -1 });

    // Package and Release Data (`writeFile` tries to write and save an XLSB file)
    XLSX.writeFile(workbook, "Report_"+new Date().toISOString()+".xlsx");
  }

  return (
    <div style={{ fontFamily: 'MavenPro' }} className='flex w-[full] overflow-scroll show-scrollbar rounded-2xl'>
      <table ref={tableRef} className={`table-fixed flex-shrink-0 ${className} rounded-2xl`}>
        <thead className='capitalize'>
          <tr>
            {
              tableHeaders.map((header) => (
                <th className='px-4 py-2 bg-gray-700 text-white text-center'>{formatFloatIfNeeded(header)}</th>
              ))
            }
          </tr>
        </thead>
        <tbody>
          {
            Object.values(tableBody).map((rows, index) => (
              <>
                {rows.map((row, i) => (
                  <tr className={`hover:bg-gray-600 hover:text-gray-100 border border-gray-900 hover:opacity:95 ${index % 2 != 0 ? 'bg-gray-200' : 'bg-white'} cursor-pointer flex-col`}>
                    {
                      i == 0 &&
                      tableBodyKeys[index].slice(0, 2).map((kv, ind) => (
                        <td rowSpan={tableBodySectionLengths[index]} className={`border border-black border-[3px] px-4 py-2 text-center`}>
                          {formatFloatIfNeeded(kv)}
                        </td>
                      ))
                    }
                    {

                      row.map((data, index) => (
                        <td className={`border border-gray-400 border-2 px-4 py-2 text-center`}>
                          {formatFloatIfNeeded(data)}
                          {/* {![10,12].includes(index)? data : parseFloat(data).toFixed(2)} */}
                        </td>
                      ))
                    }
                    {
                      i == 0 &&
                      tableBodyKeys[index].slice(2).map((kv) => (
                        <td rowSpan={tableBodySectionLengths[index]} className={`border border-black border-[3px] px-4 py-2 text-center`}>
                          {formatFloatIfNeeded(kv)}
                        </td>
                      ))
                    }
                  </tr>
                ))}
              </>
            ))
          }
        </tbody>
      </table>
      <IconButton onClick={onCloseClick} boxClassName={'bg-red-700 border-red-700 hover:bg-red-800 absolute duration-300 px-3 top-1 right-1 h-10 w-10 text-white'} icon={faClose} />
      <IconButton onClick={save} title={'Save'} boxClassName={'bg-green-700 border-green-700 hover:bg-green-800 absolute duration-300 px-3 bottom-0 left-5 h-10 text-white'} icon={faSave} />
    </div >
  )
}
